import { render, staticRenderFns } from "./Comp1.vue?vue&type=template&id=7e56f30b&scoped=true"
import script from "./Comp1.vue?vue&type=script&lang=ts"
export * from "./Comp1.vue?vue&type=script&lang=ts"
import style0 from "./Comp1.vue?vue&type=style&index=0&id=7e56f30b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56f30b",
  null
  
)

export default component.exports